import { render, staticRenderFns } from "./DealerIncentivesWidget.vue?vue&type=template&id=0228e9e2"
import script from "./DealerIncentivesWidget.vue?vue&type=script&lang=js"
export * from "./DealerIncentivesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports